<template>
  <platform>
    <template slot="content">
      <div class="auth">
          <el-card  shadow="never">
              <component :is="isView"/>
          </el-card>
        <div class="center">
            <el-button @click="toggleView" type="text">
              {{ buttonInfo }}
            </el-button>
        </div>
      </div>
    </template>
  </platform></template>

<script>
import Login from './Login'
import SignUp from './SignUp'
import { isUserAuthenticated } from '@/services/auth'

export default {
  name: 'Auth',
  components: {
    Login,
    SignUp
  },
  data () {
    return {
      isView: 'Login',
      buttonInfo: 'Don\'t have an account? Create now'
    }
  },
  watch: {
    '$route' (to) {
      this.changeRoute(to.query.isView)
    }
  },

  beforeRouteEnter (to, from, next) {
    // redirect the user to the homepage if they are loggedin already
    next(vm => {
      isUserAuthenticated(to.matched)
        .then(res => {
          // redirect based on passenger vs admin
          vm.$router.push('/')
        })
        .catch(() => {
          // just stay silence
        })
    })
  },

  methods: {
    toggleView () {
      if (this.isView === 'Login') {
        this.isView = 'SignUp'
      } else {
        this.isView = 'Login'
      }
      const routeName = this.$router.name
      this.$router.push({ name: routeName, query: { isView: this.isView } })
    },

    changeRoute (viewMode) {
      switch (viewMode) {
        case 'SignUp':
          this.buttonInfo = 'Already have an account.'
          break
        case 'Login':
          this.buttonInfo = 'I want to create an account.'
          break
        default:
          this.buttonInfo = 'Alrady have an acount.'
      }
      this.isView = viewMode
    }
  }
}
</script>

<style  scoped src="./Auth.scss">
</style>



// WEBPACK FOOTER //
// src/components/auth/Auth.vue